module.exports = __webpack_public_path__ + "static/quiz_stage_2_bg-2fdb8224bb7f9c4b31ccbebc4c2aa0d9.svg";